import React from "react";
import { Link } from "react-router-dom";
import { Button, Tooltip } from "xsolla-uikit";
import styled, { css } from "styled-components";


const CssButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8em 1.2em;
  /* background: white; */
  /* color: #0073f7; */
  color: #0076FF;
  border: 1px solid #0076FF;
  background: #FFF;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 3px;
  margin-bottom: 8px;
  ${({disabled}) => disabled && css`
    color: #D6E0E7;
    border: 1px solid #D6E0E7;
  `};
`;

const CssButH = styled.div`
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  /* padding: 0.8em 1.2em; */
  max-width: 120px;
  text-align: center;
  color: white;
  font-size: 12px;
  line-height: 120%;
  font-weight: bold;
  /* text-transform: uppercase; */
  border-radius: 3px;
`;




export const game_keys = [
    {
      product: "game_keys",
      sku: "my_project",
      name: "Cyberpunk 2088",
      price: "$19.99",
      id: "cyberpunk_2088",
      img: () => {
        return (
          <div className="">
            <Tooltip label="Click to test payment in a sandbox mode">
              <CssButton>Buy&nbsp;now&nbsp;$19.99</CssButton>
            </Tooltip>
            {/* <CssButH>
          My Game: Ultimate Edition
        </CssButH> */}
          </div>
        );
      },
      status: "active",
      used: [
        {
          product: "site_builder",
          name: "Landing page",
          action: "/game_store/my_project",
          status: "active"
        },
        {
          product: "launcher",
          name: "My Game Launcher",
          action: "/launcher/my_project/",
          status: "draft"
        },
        {
          product: "game_store",
          name: "Widget",
          action: "/game_store/new_widget",
          status: "active"
        },
        {
          product: "store",
          name: "Purchase URL",
          action: "/game_store/my_project#url",
          status: "active"
        }
      ],
      button: () => {
        return (
          <Link to="/game_store/my_project">
            <Button appearance="outline">Edit settings</Button>
          </Link>
        );
      }
    },

    {
      product: "game_keys",
      sku: "my_project",
      price: "$29.99",
      name: "Cyberpunk 2088 Standard Edition",
      id: "cyberpunk_2088",
      img: () => {
        return (
          <div className="">
            <Tooltip label="Click to test payment in a sandbox mode">
              <CssButton>Pre-order&nbsp;$119.99</CssButton>
            </Tooltip>
            {/* <CssButH>
          My Game: Ultimate Edition
        </CssButH> */}
          </div>
        );
      },
      status: "active",
      used: [
        {
          product: "launcher",
          name: "My Game Launcher",
          action: "/launcher/my_project/",
          status: "draft"
        },
        {
          product: "store",
          name: "Purchase URL",
          action: "/game_store/my_project#url",
          status: "active"
        }
      ],
      button: () => {
        return (
          <Link to="/game_store/my_project">
            <Button appearance="outline">Edit settings</Button>
          </Link>
        );
      }
    },

    {
      product: "game_keys",
      sku: "my_project3",
      name: "Cyberpunk 2019 Standard Edition",
      price: "$39.99",
      id: "cyberpunk_2019_stnd",
      // img:"https://res.cloudinary.com/maiik/image/upload/v1564044678/Xsolla_PA/temp/Frame_3.16.png",
      img: () => {
        return (
          <Tooltip label="Finish setting up the button">
            <CssButton disabled={true}>Pre-order&nbsp;$11.99</CssButton>
          </Tooltip>
        );
      },
      status: "draft",
      used: [],
      todo: [
        // {
        //   title: "Set up return policy",
        //   url: "/game_store/return_policy",
        //   value: 0.5
        // },
      ]
    },

    {
      product: 'game_keys',
      sku: 'my_project_another',
      price: "—",
      name: "Cyberpunk 2019 Collectors Edition",
      id: "cyberpunk_2019_collectors",
      img: ()=>{return <div className="">
        <Tooltip label="Click to test payment in a sandbox mode">
          <CssButton>Buy&nbsp;now&nbsp;$129.99</CssButton>
        </Tooltip>
        {/* <CssButH>
          My Game: Ultimate Edition
        </CssButH> */}
      </div>},
      status: "draft",
      used: [],
      // todo: [
      //   {
      //     title: "Finish setting up",
      //     value: 0.5
      //   },
      //   ],
    },
  ];